import * as React from "react";
import {
  Block,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  Link,
  BlockTitle,
} from "framework7-react";
    
export default class BattlesPage extends React.Component {
  public render() {
    return (
      <Page>
        <Navbar>
          <NavLeft leftBreakpoint={800}>
            <Link panelOpen="left">
              <i className="icon icon-menu" />
            </Link>
          </NavLeft>
          <NavTitle>Battles</NavTitle>
        </Navbar>
        <BlockTitle>Subtitulo</BlockTitle>
        <Block>
          <h1>Battles</h1>
        </Block>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/BattlesPage.tsx